import { getBackendClient } from "@/lib/backend";
import type { DocumentType } from "./pdf-document-type";

/**
 * Fire-and-forget `pdf-react-generate` after a **new** invoice, estimate, or PO
 * is created (see create mutations). Skipped when the create flow sets
 * `merged_into_existing`. Uses `force: false` so an existing stored PDF is not
 * overwritten.
 *
 * This function is only the direct-invoke path for create flows.
 *
 * The schema also includes `pdf_generation_queue` plus
 * `pdf_enqueue_document` / `pdf_cleanup_old_queue_entries`
 * (`migrations/20260617050000_baseline-05-functions.sql`), and database
 * triggers such as `pdf_simple_invoices` / `pdf_related_invoice_lines` enqueue
 * PDF work on document changes.
 */
export function triggerAutoPdf(documentType: DocumentType, documentId: string): void {
  const backend = getBackendClient();

  backend.functions
    .invoke("pdf-react-generate", {
      body: {
        documentType,
        documentId,
        force: false,
      },
    })
    .catch((error: unknown) => {
      console.warn(
        `[auto-pdf] Background PDF generation failed for ${documentType} ${documentId}:`,
        error,
      );
    });
}
